import i18n from '@/plugins/i18n'
import axios from '@/plugins/axios'

export default [
    {
        name: 'Dashboard',
        icon: 'mdi-view-dashboard',
        path: '/',
    },
    {
        name: 'Prospects',
        icon: 'mdi-briefcase-search',
        path: '/' + i18n.t('prospects.routes.index'),
    },
    {
        name: 'Customers',
        icon: 'mdi-account-group',
        path: '/' + i18n.t('customer.routes.index'),
    },
    {
        name: 'Commissions',
        icon: 'mdi-cash',
        path: '/' + i18n.t('commissions.routes.index'),
    },
    {
        name: 'ERP',
        icon: 'mdi-airplay',
        children: [
            {
                name: 'Colors',
                path: '/colors',
            },
            {
                name: 'Contents',
                path: '/contents',
            },
            {
                name: 'Modules',
                path: '/modules',
            },
            {
                name: 'Email',
                path: '/emails',
            },
        ],
        permission: 'reseller/isWhitelabel',
    },
    {
        name: 'Bills',
        icon: 'mdi-currency-usd',
        path: '/' + i18n.t('bills.routes.index'),
        permission: 'reseller/billable',
    },
    {
        name: 'Marketing',
        icon: 'mdi-bullhorn',
        children: [
            {
                name: 'Files',
                href: 'https://lps.connectplug.com.br/materiais-parceiros/',
                permission: 'reseller/isNotWhitelabel',
            },
            {
                name: 'Landing Pages',
                path: '/' + i18n.t('routes.landingPage.index'),
                permission: 'reseller/isNotWhitelabel',
            },
        ],
    },
    {
        name: 'Categories',
        icon: 'mdi-seal',
        path: '/' + i18n.t('routes.category.index'),
        //permission: 'index categories',
        permission: 'reseller/billable',
    },
    {
        name: 'Certificates',
        icon: 'mdi-key',
        path: '/' + i18n.t('certificates.routes.index'),
    },
    {
        name: 'Settings',
        icon: 'mdi-settings',
        children: [
            {
                name: 'Empresa',
                path: '/' + i18n.t('reseller.routes.edit'),
            },
            {
                name: 'Contatos',
                path: '/' + i18n.t('routes.contact.index'),
            },
            {
                name: 'Bank Accounts',
                path: '/' + i18n.t('bank-account.routes.index'),
            },
            {
                name: 'Addresses',
                path: '/' + i18n.t('address.routes.index'),
            },
            {
                name: 'Users',
                path: '/' + i18n.t('user.routes.index'),
            },
            {
                name: 'Roles',
                path: '/' + i18n.t('roles.routes.index'),
            },
            {
                name: 'Mails',
                path: '/' + i18n.t('routes.mail.index'),
            },
            {
                name: 'Integrations',
                path: '/' + i18n.t('routes.integration.index'),
            },
        ],
    },
    {
        name: 'Support',
        icon: 'mdi-help-circle-outline',
        children: [
            {
                name: 'Help Center',
                path: '/' + i18n.t('help-center.routes.index'),
            },
            {
                name: 'Help Me',
                mutator: 'support/switchDialogState',
                permission: 'reseller/hasSupport',
            },
            {
                name: 'Tickets',
                permission: 'reseller/hasSupport',
                handle: async () => {
                    let res = await axios.get('help-center/support-link')
                    if (!res) return null
                    window.open(res.data.url, '_blank')
                },
            },
        ],
    },
]
